import api from '@Services/api';
import { AxiosResponse } from 'axios';
import { Slot, WebinarSlotsPayload } from '../../Types/Webinar.types';

import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';

interface SlotCRUD extends CRUDBase<WebinarSlotsPayload, Slot> {}
export class WebinarSlotsRequester implements SlotCRUD {
	private static instance: WebinarSlotsRequester;
	static getInstance() {
		if (!WebinarSlotsRequester.instance) {
			WebinarSlotsRequester.instance = new WebinarSlotsRequester();
		}
		return WebinarSlotsRequester.instance;
	}
	baseURL = '/webinar/slot';
	getAll(payload?: GetAllMeta): Promise<AxiosResponse<ApiResponse<Slot[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<Slot[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Slot[]>>> {
		return await api.post(`${this.baseURL}/all`, payload);
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<Slot>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<Slot>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<Slot>>>;
	async get(id: any, payload?: any): Promise<AxiosResponse<ApiResponse<Slot>>> {
		return await api.post(`/${this.baseURL}/get`, { id });
	}
	async create(
		payload: WebinarSlotsPayload
	): Promise<AxiosResponse<ApiResponse<Slot>>> {
		return await api.post(`${this.baseURL}/add`, payload);
	}
	async update(
		payload: WebinarSlotsPayload
	): Promise<AxiosResponse<ApiResponse<Slot>>> {
		return await api.put(`${this.baseURL}/update`, payload);
	}

	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<Slot>>>;
	async delete(
		id: any,
		payload?: any
	): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.delete(`${this.baseURL}/delete`, {
			data: {
				id,
			},
		});
	}
}
